import { TAResponse3 } from 'api/tripadvisor/types';
import classNames from 'classnames';
import { Button } from 'components/blocks/Button';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import React, { useCallback } from 'react';
import { ReactComponent as SvgDeal } from 'public/assets/icons/deal.svg';
import Loader from 'react-spinners/PuffLoader';
import theme from 'theme';
import { LodgingDataEvent, useAnalytics } from 'util/analytics';

import styles from './styles.module.scss';

const additionalClasses: Record<string, string> = {
  pending: styles.pending,
  unavailable: styles.unavailable,
};

export const Offer = ({ offer, dataClickCategory, dataClickId }:{ offer: TAResponse3.Offer, dataClickId?: string;
  dataClickCategory?: string; }) => {
  const { t } = useOTSTranslation('common');

  const a = useAnalytics();

  const onClick = useCallback(() => {
    a.logdingEvent(LodgingDataEvent.ViewOffer, {
      hotelName: offer.displayName,
    });
  }, [a, offer.displayName]);

  return (
    <div className={classNames(styles.box, additionalClasses[offer.availability])}>
      <div className={styles.info}>
        {offer.availability !== 'pending' && <div className={styles.price}>{offer.displayPrice || ''}</div>}
        {offer.availability === 'pending' && (
        <Loader
          color={theme.primary}
          size={32}
        />
        )}
      </div>
      <a href={offer.clickUrl} target="_blank" rel="noreferrer nofollow noopener" data-click-category={dataClickCategory} data-click-id={dataClickId}>
        <Button className={styles.button} onClick={onClick}>
          <SvgDeal />
          <span>{t('resort.lodging.viewDeal')}</span>
        </Button>
      </a>
    </div>
  );
};
